export enum Routes {
    DASHBOARD = 'tasks',
    FINISHOPERATION = 'finishOperation',
    INTRO = 'intro',
    DOCUMENT = 'document',
    ERROR = 'error',
    STATUS = 'signature-status',
    THANKS = 'thanks',
    LOGIN = 'login',
    CUSTOM_CHECKBOX = 'custom-checkbox',
    NOTE = 'operation-NOTE',
    FINISH_SIMPLE = 'simple'
}
